/**
 * Complete list of react-router path patterns registered by the app.
 * App-level catch-all (`*`) is intentionally excluded — that renders NotFound.
 * Nested settings catch-all (`/settings/*`) is included (SettingsUnavailablePage).
 */
export const DEFINED_ROUTE_PATTERNS = [
  '/',
  '/account-recovery',
  '/account-recovery/complete',
  '/account/scheduled-deletion/:token',
  '/activate',
  '/activate/first-listing',
  '/activate/invite-team',
  '/activate/portal-credentials',
  '/activate/welcome',
  '/activate/whatsapp',
  '/activate/working-hours',
  '/admin/areas',
  '/admin/areas/:areaId/signals',
  '/admin/areas/:id',
  '/admin/areas/new',
  '/admin/audit',
  '/admin/audit/retention',
  '/admin/comment-classifier',
  '/admin/fin',
  '/admin/fin/accounting/periods',
  '/admin/fin/accounting/periods/:id',
  '/admin/fin/approvals',
  '/admin/fin/approvals/:id/audit',
  '/admin/fin/audit',
  '/admin/fin/billing/periods/:id/close',
  '/admin/fin/configuration',
  '/admin/fin/contracts',
  '/admin/fin/contracts/:contractId/versions/new',
  '/admin/fin/contracts/:id',
  '/admin/fin/credits',
  '/admin/fin/credits/fin-mirror',
  '/admin/fin/credits/janitor',
  '/admin/fin/credits/lots',
  '/admin/fin/dunning',
  '/admin/fin/dunning/:id',
  '/admin/fin/dunning/:id/advance',
  '/admin/fin/dunning/:id/cure',
  '/admin/fin/dunning/:id/write-off',
  '/admin/fin/exceptions',
  '/admin/fin/exceptions/:id',
  '/admin/fin/facilities',
  '/admin/fin/holds',
  '/admin/fin/invoices',
  '/admin/fin/overview',
  '/admin/fin/package-approvals',
  '/admin/fin/packages',
  '/admin/fin/packages/:id',
  '/admin/fin/packages/:id/versions/:vid',
  '/admin/fin/packages/features',
  '/admin/fin/payments',
  '/admin/fin/pricing',
  '/admin/fin/pricing/:id',
  '/admin/fin/reconciliation',
  '/admin/fin/reconciliation/:id',
  '/admin/fin/subscriptions',
  '/admin/fin/subscriptions/:id',
  '/admin/fin/tenants',
  '/admin/fin/tenants/:id',
  '/admin/fin/usage',
  '/admin/fin/vendor-costs',
  '/admin/fin/vendors/:id',
  '/admin/fin/vendors/:vendorId/statements/:month',
  '/admin/google-usage',
  '/admin/markets',
  '/admin/message-templates',
  '/admin/message-templates/:id',
  '/admin/message-templates/new',
  '/admin/moderation/portals',
  '/admin/notifications/dead-letter',
  '/admin/packages',
  '/admin/packages/:packageId/history',
  '/admin/packages/:packageId/versions/:version',
  '/admin/packages/:packageId/versions/:versionId/edit',
  '/admin/packages/approvals',
  '/admin/packages/approvals/:versionId',
  '/admin/portals',
  '/admin/portals/:code',
  '/admin/portals/:code/edit',
  '/admin/portals/:code/history',
  '/admin/portals/new',
  '/admin/pricing',
  '/admin/pricing/canonical',
  '/admin/pricing/canonical/:id',
  '/admin/scoring',
  '/admin/scoring/ai-configs',
  '/admin/strategy/config',
  '/admin/support/account-recovery',
  '/admin/support/account-recovery/:caseId',
  '/admin/trust',
  '/admin/valuation/comparable-reports',
  '/admin/valuation/comparable-reports/:reportId',
  '/admin/valuation/price-reports',
  '/admin/valuation/price-reports/:reportId',
  '/admin/whatsapp-listings',
  '/admin/whatsapp-listings/audit',
  '/agencies/:agencySlug/apply',
  '/agency',
  '/agency/applications/:appId/status',
  '/agency/credits',
  '/agency/credits/allocation-rules',
  '/agency/credits/quotas',
  '/agency/members/applications',
  '/agency/members/applications/:applicationId',
  '/agency/onboarding',
  '/agency/ownership-transfer/incoming/:transferId',
  '/agency/pricing',
  '/agency/pricing/bulk-adjust',
  '/agency/pricing/comparables',
  '/agency/public-profile',
  '/agency/reports',
  '/agency/reports/agents',
  '/agency/reports/attribution',
  '/agency/reports/campaigns',
  '/agency/reports/leads',
  '/agency/reports/listings',
  '/agency/reports/revenue',
  '/agency/routing',
  '/agency/routing/rules/:ruleId',
  '/agency/settings',
  '/agency/settings/audit',
  '/agency/settings/branding',
  '/agency/settings/contact-policy',
  '/agency/settings/delete-agency',
  '/agency/settings/ownership-transfer',
  '/agency/settings/roles',
  '/agency/settings/roles/:packId',
  '/agency/settings/security',
  '/agency/templates',
  '/agency/templates/:templateId',
  '/agency/whatsapp-listings',
  '/agency/white-label/analytics',
  '/agency/white-label/copy',
  '/agent/:id',
  '/agent/comparable-reports/:id',
  '/agent/pricing',
  '/agent/areas/:slug/xray',
  '/agent/pricing/brief',
  '/agent/pricing/reports',
  '/agent/pricing/reports/:id/outcome',
  '/agent/pricing/reports/new',
  '/agent/profile',
  '/agent/reviews',
  '/agent/calendar',
  '/agent/whatsapp-listings',
  '/agent/whatsapp-listings/analytics',
  '/agent/whatsapp-listings/settings',
  '/analytics/crm',
  '/applications/:applicationId',
  '/areas/:slug',
  '/audiences',
  '/audiences/:id',
  '/audiences/new',
  '/book/:token',
  '/calendar',
  '/campaigns',
  '/campaigns/:id',
  '/campaigns/new',
  '/campaigns/paid/new',
  '/command-center',
  '/comparables/:comparableId/report',
  '/contacts',
  '/contacts/:contactId/relationships',
  '/contacts/:id',
  '/contacts/:id/edit',
  '/contacts/new/full',
  '/cookies',
  '/dashboard',
  '/dashboard/inbox',
  '/dashboard/inbox/:conversationId',
  '/experiments',
  '/experiments/:id',
  '/experiments/:id/results',
  '/experiments/new',
  '/forgot-password',
  '/inbox',
  '/inbox/:conversationId',
  '/inbox/applications/:applicationId',
  '/inbox/ownership-transfers/:transferId',
  '/inspector',
  '/inspector/:id/submit',
  '/integrations',
  '/join/:invitationCode',
  '/journeys',
  '/journeys/:id/edit',
  '/journeys/new',
  '/journeys/runs/:runId',
  '/listings',
  '/listings/:id',
  '/listings/:id/disposition',
  '/listings/:id/edit',
  '/listings/:id/neighborhood-valuator',
  '/listings/:id/portals/submit',
  '/listings/:id/report',
  '/listings/new',
  '/login',
  '/marketing',
  '/message-templates',
  '/message-templates/:id',
  '/message-templates/new',
  '/my-credit-notes',
  '/my-credits',
  '/my-invoices',
  '/my-subscription',
  '/notification-preferences',
  '/notifications',
  '/onboarding',
  '/onboarding/first-listing/:draftId',
  '/onboarding/first-listing/published',
  '/onboarding/markets',
  '/onboarding/welcome',
  '/onboarding/whatsapp',
  '/onboarding/whatsapp/code',
  '/onboarding/whatsapp/connect',
  '/onboarding/whatsapp/drafting/:sessionId',
  '/onboarding/whatsapp/waiting',
  '/operations',
  '/opportunities',
  '/opportunities/:id',
  '/plans',
  '/privacy',
  '/public/agency/:id',
  '/public/agent/:id',
  '/public/relationships/consent',
  '/publish/outcome/:id',
  '/publishing/receipts/:id',
  '/publishing/tracker',
  '/r/:shareToken',
  '/refund',
  '/register',
  '/reports/comparables/:reportId/outcome',
  '/reports/comparables/new',
  '/reports/prices/:reportId/outcome',
  '/reports/prices/new',
  '/reset-password',
  '/settings',
  '/settings/*',
  '/settings/2fa',
  '/settings/2fa/backup-codes',
  '/settings/2fa/enroll',
  '/settings/2fa/passkeys',
  '/settings/account',
  '/settings/account/delete',
  '/settings/account/locale',
  '/settings/account/timezone',
  '/settings/api-tokens',
  '/settings/billing',
  '/settings/channels',
  '/settings/channels/whatsapp/code',
  '/settings/channels/whatsapp/connect',
  '/settings/danger/delete-account',
  '/settings/data-export',
  '/settings/delete-account',
  '/settings/developer/api-tokens',
  '/settings/historical-transactions',
  '/settings/notifications',
  '/settings/notifications/billing',
  '/settings/password',
  '/settings/preferences',
  '/settings/privacy/data-export',
  '/settings/reminders',
  '/settings/routing',
  '/settings/saved-searches',
  '/settings/security/2fa',
  '/settings/security/2fa/*',
  '/settings/security/password',
  '/settings/security/sessions',
  '/settings/sessions',
  '/site/:subdomain',
  '/site/:subdomain/property/:propertyId',
  '/tasks',
  '/terms',
  '/trust',
  '/trust/subprocessors/confirm',
  '/trust/subprocessors/unsubscribe',
  '/trust/vulnerability-disclosure',
  '/white-label',
  '/widgets',
] as const

export type DefinedRoutePattern = (typeof DEFINED_ROUTE_PATTERNS)[number]
